export type DeleteEntityRequest = {
    entityId: number
}

export const DeleteEntityRequestInit: DeleteEntityRequest = {
    entityId: 0
}